var FaqBlock = /** @class */ (function () {
    function FaqBlock(element) {
        this.faqBlock = element;
        this.faqItem = this.faqBlock.querySelectorAll('[data-faq-item]');
        if (this.faqItem) {
            this.init();
        }
    }
    FaqBlock.prototype.init = function () {
        var _this = this;
        this.faqItem.forEach(function (item) {
            var itemTitle = item.querySelector('.faq-item-title > h5');
            var itemToggle = item.querySelector('.faq-item-toggle');
            itemTitle.addEventListener('click', function (event) { return _this.toggleFaqItem(item); });
            itemToggle.addEventListener('click', function (event) { return _this.toggleFaqItem(item); });
        });
    };
    FaqBlock.prototype.toggleFaqItem = function (faqItem) {
        var faqContentIsOpen = faqItem.classList.contains('active');
        if (faqContentIsOpen) {
            faqItem.classList.remove('active');
        }
        else {
            faqItem.classList.add('active');
        }
    };
    return FaqBlock;
}());
export default FaqBlock;
var faqBlocks = document.querySelectorAll('[data-faq-block]');
faqBlocks.forEach(function (faqBlock) {
    new FaqBlock(faqBlock);
});
